/**
 * Created by MeePwn
 * https://github.com/maybewaityou
 *
 * description:
 * 小程序作品
 */
import { Base64 } from 'js-base64';
import { RenderStrategy, RenderType } from './RenderStrategy';
import { dynamicLoadPanoXML, reloadPanoVideoXML } from '../../../panoramic/PanoramicView';
import { delay, getQueryString, panoPicture, panoVideo } from '../../../../utils/functional';
import { setPanoData, transformToPanoData, addPanoData, setResetData } from '../../../panoramic/data';
import { fetchDataConfigById, fetchBackgroundMusicURL, } from '../../../../api/NetworkApi';
import { processURL } from '../../../../utils/data';

export class UserWorksRenderStrategy extends RenderStrategy {
  protected renderType: RenderType = RenderType.USER_WORKS;

  public apply(params?: any) {
    const { tipControl, hooks: { setPanoConfig, setBGMItem, setOrderData } } = params;

    const id = getQueryString('userWorksId');
    tipControl.showLoading();
    fetchDataConfigById(id)
      .then(async ([error, result]) => {
        tipControl.dismissLoading();
        if (error) return tipControl.showToast(error);
        // alert(`${JSON.stringify(setOrderData)} ${JSON.stringify(result)}`)
        setOrderData(result);
        // const config = JSON.parse(Base64.decode(`
        // eyJzY2VuZSI6W3siaWQiOjEsInVybCI6Imh0dHA6Ly9maWxlLnRlc3QucnVuYm8zNjBmaWVsZC5jb20vcGhvdG9zL2RhdGEvMjAyMDExMjYxMDAyMDAwMTcvdGlsZXMiLCJzcGhlcmV1cmwiOiIiLCJza3kiOiIiLCJ0aXRsZSI6IiIsInN0aWNrZXIiOlt7InVybCI6ImltZy9zdGlja2VyL3N0aWNrZXItMi5wbmciLCJzY2FsZSI6MSwiYXR2IjotMTAuMTAyMzM0Nzc2MjY3NjU1LCJhdGgiOi00OC42NjQ2MzAxNDQxMDY3NCwiZnJhbWVyYXRlIjoyMH0seyJ1cmwiOiJpbWcvc3RpY2tlci9zdGlja2VyLTEucG5nIiwic2NhbGUiOjEsImF0diI6OS4yODc2MjI2NzU5MDA1MjIsImF0aCI6MTMuOTk3NjY4MjM2MjE2NjY4LCJmcmFtZXJhdGUiOjIwfSx7InVybCI6ImltZy9zdGlja2VyL3N0aWNrZXItNy5wbmciLCJzY2FsZSI6MSwiYXR2IjotNS43ODUyNDMzOTYxMDQ1ODQsImF0aCI6MTA0Ljc5MjI4MTY1MTc0NTMsImZyYW1lcmF0ZSI6MjB9XSwidGV4dHN0aWNrZXIiOltdLCJ0ZXh0U3RpY2tlciI6W3siaWQiOiJ0ZXh0LXN0aWNrZXItNCIsInRleHQiOiJoYWhhIiwiYXR2IjoiLTMxLjIzOTQzMTMzODkyODk1MiIsImF0aCI6IjEuMjE0ODI4MDY2ODE5OTA1In0seyJpZCI6InRleHQtc3RpY2tlci02OSIsInRleHQiOiLoirEiLCJhdHYiOiItMTcuOTMwMzM1MzA5Nzk2MjczIiwiYXRoIjoiLTEzNS44NTcxMDg0NzU5MTYyOCJ9XX1dLCJhdXRvcm90YXRlIjp7ImVuYWJsZWQiOiJ0cnVlIiwidHlwZSI6IjEifSwibXVzaWMiOiJodHRwczovL211c2ljLmFtZS5xY2xvdWQuY29tL3ByZXZpZXcvMzYvMDA4LzM2MDA4Mzg3LU1QMy02NEstRlRELVAubXAzP3NpZ25BPTE2MTAzNDc4MzctV1RXWExMQUEtMC02NzcwNzdmNDRjY2I1NWE1MzY0Yjg0MjkyMmZmNGNmMSZzaWduPWZlYjQxZGU5NTQ4OGE3YmVhNmNhMTZjNzY5ZTM2YjFjJnQ9NWZmYzBhNTUmdHJhbnNEZWxpdmVyeUNvZGU9Q0FAMEAxNjEwMzQ3ODM3QFNAMjRjM2M1Njg4MmY4MjEyNiIsImJnbUl0ZW0iOnsiZ3JvdXBJRCI6IjU3NDc3ODM3MkMyQkQ3ODQiLCJ0aXRsZSI6Iui/t+WkseW5u+WigyIsImltYWdlIjoiaHR0cDovL2ltYWdlLnRpbmdtYWxsLmNvbS9hbGJ1bS81MjIvNTIyMTg4NS1KUEctMjQwWDI0MC1BTEJVTS5qcGciLCJzZWxlY3RlZCI6dHJ1ZSwidmFsdWUiOiJBRTk2NEIyQjBBRTM0QkI4NTU2OUJCNDBBRjdBRUYwOCIsInVybCI6Imh0dHBzOi8vbXVzaWMuYW1lLnFjbG91ZC5jb20vcHJldmlldy8zNi8wMDgvMzYwMDgzODctTVAzLTY0Sy1GVEQtUC5tcDM/c2lnbkE9MTYxMDM0NzcxNy1ZQVdGWkFOWS0wLTI2MzA4OTg5ZTlkMGIzYzEwMTg3MDk0YTM4ODBiZGExJnNpZ249YmE5MjI5MzI0NzQ0YzZkMThmNWUxZGI2MDc2MmJjMzMmdD01ZmZjMDlkZCZ0cmFuc0RlbGl2ZXJ5Q29kZT1DQUAwQDE2MTAzNDc3MTdAU0AyNGMzYzU2ODgyZjgyMTI2In0sInNub3ciOnsidHlwZSI6ImR5bmFtaWMtMSJ9LCJ0b3BpbWciOnsidXJsIjoiaW1nL2ZyYW1lL2ZyYW1lLTIyLnBuZyIsImZyYW1lcmF0ZSI6IjEwIn0sInpmaWx0ZXIiOnsidmFsdWUiOiJlYXJseWJpcmQiLCJnYW1tYSI6IiIsImJyaWdodG5lc3MiOjAsImNvbnRyYXN0IjowLCJleHBvc3VyZSI6MCwiaHVlIjowLCJzYXR1cmF0aW9uIjowLCJ2aWJyYW5jZSI6MCwic2VwaWEiOjAsInN3aXJsIjowLCJwaXhlbGF0ZSI6MCwicmlwcGxlIjowLCJzb2JlbCI6MCwic3BsaXQiOjAsImZxdWFsaXR5IjoxNSwiZmJsdXIiOjAsImJsdXIiOjAsImJsZW5kbW9kZSI6ImFkZCIsImJsZW5kY29sb3IiOiIweDAiLCJ2aWduZXR0ZWNvbG9yIjoiMHgwIiwibWl4Y29sb3IiOiIweDAifX0=
        // `));

        const config = JSON.parse(Base64.decode(result.data));
        addPanoData(config); // 补充默认玩图数据
        const data = config.scene ? config : transformToPanoData(config);
        // data.scene[0].sphereurl = data.scene[0].sphereurl.replace('https', 'http');
        // data.scene[0].video = data.scene[0].video.replace('https', 'http');
        console.log(data);

        // 设置 PanoData, PanoXML 加载时会读取 PanoData, 并还原设置

        if (panoPicture()) {
          setPanoData(data);
          setResetData(data);
          setPanoConfig(data);
          if (!data.bgmItem.value) return dynamicLoadPanoXML();
        }

        if (panoVideo()) {
          // 重拍-获取新封面
          data.scene[0].poster = processURL(result.poster_url || data.scene[0].poster);
          setResetData(data);
          setPanoData(data);
          // setPanoData({
          //   ...data,
          //   topimg: {
          //     ...data.topimg,
          //     url: '',
          //   }
          // });

          // setPanoConfig(data);
          if (!data.bgmItem.value) return reloadPanoVideoXML();
        }

        const [bgmError, bgmResult] = await fetchBackgroundMusicURL(data.bgmItem.value);
        if (bgmError) return tipControl.showToast(bgmError);

        let resultData;
        try {
          resultData = JSON.parse(Base64.decode(bgmResult.data));
        } catch (error) {
          console.log(error);
          // return;
        }
        if (!resultData || !resultData.data) {
          // tipControl.showToast(`${resultData.code} - ${resultData.msg}`);
          if (panoPicture()) dynamicLoadPanoXML();
          if (panoVideo()) reloadPanoVideoXML();
        } else {
          const { url } = resultData.data;
          if (url) {
            data.music = url;
            const extraItem = { ...data.bgmItem, url, shouldPlay: false, };
            setPanoData(data);
            if (panoPicture()) dynamicLoadPanoXML();
            if (panoVideo()) reloadPanoVideoXML();
            setPanoConfig(data);
            setBGMItem(extraItem);

            // handleBGMItemClick(extraItem);
          }
        }
      }).catch((error) => {
        console.log(error);
      });
  }
}
